import Vue from 'vue';
import Vuex from 'vuex';

import history from './modules/history';
import app_settings from './modules/app-settings';
import page_loader from './modules/page-loader';
import token from './modules/token';
import tracing from './modules/tracing';
import lookups from './modules/lookups';
import quote from './modules/quote';
import quote_questions from './modules/quote/questions';
import quote_results from './modules/quote-results';

import error from './modules/error';
import storage from './modules/storage';
import session from './modules/session';

// import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    history,
    app_settings,
    page_loader,
    token,
    tracing,
    lookups,
    quote,
    quote_questions,
    quote_results,

    error,
    storage,
    session
  }
});
